import { rem } from "@huub-web/utils/css/rem";
import { recipe } from "@vanilla-extract/recipes";

import { theme } from "../../theme/css/theme.css";

export const headerStyle = recipe({
  base: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacings.xs,
    minHeight: rem(71),
    flexGrow: 0,
    flexShrink: 0,
  },
  variants: {
    variant: {
      default: {
        padding: `0 ${theme.spacings.m}`,
      },
      compact: {
        paddingRight: theme.spacings.m,
      },
      sideContent: {
        paddingRight: theme.spacings.m,
      },
    },
  },
});

// export const timeIndicationStyle = style({
//   gap: theme.spacings.xxs,
// });

// export const dotStyle = style({
//   height: "16px",
//   transform: "translateY(-5px)",
// });
